import { render } from "./PaymentError.vue?vue&type=template&id=23104e8f&scoped=true"
import script from "./PaymentError.vue?vue&type=script&lang=js"
export * from "./PaymentError.vue?vue&type=script&lang=js"

import "./PaymentError.vue?vue&type=style&index=0&id=23104e8f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23104e8f"]])

export default __exports__